import { render, staticRenderFns } from "./softList.vue?vue&type=template&id=f8c70210&scoped=true&"
import script from "./softList.vue?vue&type=script&lang=js&"
export * from "./softList.vue?vue&type=script&lang=js&"
import style0 from "./softList.vue?vue&type=style&index=0&id=f8c70210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c70210",
  null
  
)

export default component.exports